var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"dense":"","flat":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Create a Business Merchant-Service Account")])]),_c('v-card-text',[_c('AccountLinkCreate',{staticClass:"mb-4",attrs:{"bizId":_vm.bizId}}),_c('Footnote')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }